import React, { FC, HTMLProps } from "react";
import cn from "classnames";
import stl from "./index.module.scss";

interface Props extends HTMLProps<HTMLDivElement> {
  direction?: "horizontal" | "vertical";
  variant?: "default";
}

const Divider: FC<Props> = ({
  direction = "horizontal",
  variant = "default",
  className,
  ...props
}) => {
  let variantClassName = "";

  switch (variant) {
    case "default": {
      variantClassName = stl.default;
      break;
    }
  }

  let directionClassName = "";

  switch (direction) {
    case "horizontal": {
      directionClassName = stl.horizontal;
      break;
    }
    case "vertical": {
      directionClassName = stl.vertical;
      break;
    }
  }

  return (
    <div
      {...props}
      className={cn(className, stl.block, variantClassName, directionClassName)}
      role="separator"
    />
  );
};

export default Divider;
